import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-matching-project-dialog',
  templateUrl: './matching-project-dialog.component.html',
  styleUrls: ['./matching-project-dialog.component.scss']
})
export class MatchingProjectDialogComponent {

  constructor(private dialogRef: MatDialogRef<MatchingProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  closeDialog() {
    this.dialogRef.close();
  }

}
